class BasketController {

    constructor(basket, order, checkout) {
        this.basket = basket;
        this.order = order;
        this.basket.contents.currency = this.currency;
        this.checkout = checkout;
    }
}

BasketController.$inject = ['basket', 'order', 'checkout'];

export default BasketController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/basket.controller.js